<div class="container mt-5"  [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside:avoid">
    <div class="row my-3">
        <div class="col-sm-12 text-right">আইটি ১০বি (২০২৩)</div>
    </div>
    <div class="row my-3">
        <div class="col-sm-12 text-center font-weight-bold">
            পরিসম্পদ দায় ও ব্যয় বিবরণী (৩০/৬/{{assessmentYearStart | convertNumWithOtherCharsToBn}} তারিখে)
        </div>
    </div>
    <div *ngIf="!returnData?.profileData?.mandatoryITTenB" class="row my-3">
        <div class="col-sm-12 text-center font-weight-bold font-italic">
            পরিসম্পদ দায় ও ব্যয় বিবরণী উক্ত করদাতার জন্য প্রযোজ্য নয়
        </div>
    </div>
    <div class="my-3">
        <div class="font-weight-bold">যাহাদের জন্য প্রযোজ্য</div>
        <ul style="padding-left:0px">
            <li>সকল গণকর্মচারী;</li>
            <li>দেশে ও বিদেশে মোট সম্পত্তির মূল্য ৫০,০০,০০০ (পঞ্চাশ লক্ষ) টাকার অধিক হইলে;</li>
            <li>যাহার মোট সম্পত্তির মূল্য ৫০,০০,০০০ (পঞ্চাশ লক্ষ) টাকার নিম্নে কিন্তু আয়বর্ষের কোন সময় মোটরযানের মালিক ছিলেন অথবা সিটি কর্পোরেশন এলাকার মধ্যে গৃহসম্পত্তি বা অ্যাপার্টমেন্টে বিনিয়োগ করিয়াছেন অথবা বিদেশে কোন পরিসম্পদের মালিক হইয়াছেন অথবা কোনো কোম্পানির শেয়ারহোল্ডার পরিচালক হইয়াছেন;</li>
            <li>অনিবাসী বাংলাদেশী স্বাভাবিক ব্যক্তি করদাতা এবং স্বাভাবিক ব্যক্তি করদাতা যিনি বাংলাদেশী নহেন তাহারা কেবল বাংলাদেশে অবস্থিত সকল সম্পদের তথ্য প্রদান করিবেন ।</li>
        </ul>
    </div>
    <div class="row my-5">
        <div class="col-sm-5">করদাতার নাম: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            টি আইএন:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div class="row mx-2">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-2">
                        <div class="col-sm-12">
                            ১। অর্জিত তহবিলসমূহ-
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ক) রিটার্নে প্রদর্শিত মোট আয় (মোট আয়ের বিবরণীর ১১ নং ক্রমিক অনুযায়ী)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.sources_of_fund?.income_shown_in_the_return?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9"  style="padding-left: 30px;">(খ) কর অব্যাহতি প্রাপ্ত আয় (রিটার্নের সাথে সংযুক্ত নির্দেশাবলী দ্রষ্টব্য)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.sources_of_fund?.tax_exempted_income_and_allowances?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9" style="padding-left: 30px;">(গ) দান-গ্রহণ/অন্যান্য প্রাপ্তি</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.sources_of_fund?.other_receipts?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row my-4">
                        <div class="col-sm-9 text-center">মোট অর্জিত তহবিল</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{totalSourcesOfFund | formatNumberReturnView}}</span></div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-9">২। বিগত আয়বর্ষের শেষ তারিখের নীট সম্পদ</div>
                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.previous_net_wealth?.previous_income_year_net_wealth?.value | formatNumberReturnView}}</span></div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-9">৩। অর্জিত তহবিল ও বিগত আয়বর্ষের শেষ তারিখের নীট সম্পদের যোগফল (১+২)</div>
                <div class="col-sm-3">টাকা <span class="ml-3">{{totalAssetsAndLastYearAssets | formatNumberReturnView}}</span></div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-2">
                        <div class="col-sm-9">৪। (ক) জীবনযাপন সংশ্লিষ্ট ব্যয়: [ফরম নং আইটি-১০বিবি অনুযায়ী মোট খরচ]</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{annualLivingExpense | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 35px;">(খ) আইটি ১০বিবি-তে উল্লিখিত হয় নাই এইরূপ দান প্রদান/ব্যয়/ক্ষতি</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{lossAndGiftExpense | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row my-4">
                        <div class="col-sm-9 text-center">মোট ব্যয় ও ক্ষতি</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{totalLivingExpense | formatNumberReturnView}}</span></div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-9">৫। এই আয়বর্ষের শেষ তারিখের নীট সম্পদ (৩-৪)</div>
                <div class="col-sm-3">টাকা <span class="ml-3">{{lastDateNetAssets | formatNumberReturnView}}</span></div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-2">
                        <div class="col-sm-12">
                            ৬। ব্যক্তিগত দায়সমূহ (ব্যবসায় বহির্ভূত)
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 35px;">(ক) প্রাতিষ্ঠানিক দায়</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.liabilities?.borrowing_from_bank_or_other_fi?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9"  style="padding-left: 35px;">(খ) অপ্রাতিষ্ঠানিক দায়</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.liabilities?.unsecured_loan?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9" style="padding-left: 35px;">(গ) অন্যান্য দায়</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.liabilities?.other_loan_or_overdraft?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row my-4">
                        <div class="col-sm-9 text-center">ব্যবসায় বহির্ভূত মোট দায়</div>
                        <div class="col-sm-3">টাকা
                            <span class="ml-3">
                                {{liabilitiesOutsideBusiness | formatNumberReturnView}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-9">৭। মোট পরিসম্পদ (ক্রমিক ৫ ও ক্রমিক ৬ এর যোগফল)</div>
                <div class="col-sm-3">টাকা
                    <span class="ml-3">
                        {{ ( lastDateNetAssets + liabilitiesOutsideBusiness) | formatNumberReturnView}}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-2">
                        <div class="col-sm-12">
                            ৮। বাংলাদেশে অবস্থিত পরিসম্পদের খাতভিত্তিক বিবরণ (প্রযোজ্য সকল ক্ষেত্রে পৃথক পৃথক বিবরণী সংযুক্ত করুন)
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ক) ব্যবসার মোট পরিসম্পদ</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{totalBusinessAssets | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(বিয়োগ) ব্যবসায়িক দায় (প্রাতিষ্ঠানিক ও অপ্রাতিষ্ঠানিক)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{businessLiabilities | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-3 bt">
                        <div class="col-sm-9" style="padding-left: 30px;">ব্যবসার মূলধন (পরিসম্পদ ও দায়ের পার্থক্য)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{(totalBusinessAssets - businessLiabilities) | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(খ) পরিচালক হিসাবে লিমিটেড কোম্পানিতে শেয়ার বিনিয়োগ</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.business_capital?.director_shareholdings_in_limited_companies?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(গ)অংশীদারী ফার্মের মূলধনের জের</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.business_capital?.capital_of_partnership_firm?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ঘ) অ-কৃষি সম্পত্তি/জমি/গৃহ সম্পত্তি (আইন সম্মত ব্যয়সহ ক্রয়মূল্য/অর্জনমূল্য/নির্মাণ ব্যয়/বিনিয়োগ)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{totalNonAgriPropertyValue | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12" style="padding-left: 30px">অকৃষি সম্পত্তির অবস্থান ও বিবরণ উল্লেখ করুন (প্রয়োজনে পৃথক কাগজে)</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9" style="padding-left: 30px;">(ঙ) কৃষি (আইনসম্মত ব্যয়সহ ক্রয়মূল্য/অর্জনমূল্য)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.agricultural_property?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2 mt-5">
                        <div class="col-sm-12" style="padding-left: 30px">মোট জমির পরিমাণ ও জমির অবস্থান উল্লেখ করুন (প্রয়োজনে পৃথক কাগজে)</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row mb-2">
                                <div class="col-sm-12" style="padding-left: 30px">
                                    (চ) আর্থিক সম্পদসমূহ
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(অ) শেয়ার/ডিবেঞ্চার/বন্ড/সিকিউরিটিস/ইউনিট সার্টিফিকেট ইত্যাদি</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.financial_assets?.share_debenture_etc?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9"  style="padding-left: 60px;">(আ) সঞ্চয়পত্র/ডিপোজিট পেনশন স্কিম</div>
                                <div class="col-sm-3">টাকা
                                    <span class="ml-3">
                                     {{(restructuredData?.assets?.financial_assets?.savings_certificate_bonds_and_other_government_securities?.value
                                        + restructuredData?.assets?.financial_assets?.dps?.value) | formatNumberReturnView}}
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(ই) ঋণ প্রদান (ঋণ গ্রহণকারীর নাম ও এনআইডি উল্লেখ করুন)</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.financial_assets?.loans_given_to_others?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div *ngIf="printActive" style="height: 80px"></div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(ঈ) সঞ্চয়ী/মেয়াদি আমানত</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.financial_assets?.fix_deposits_term_deposits_and_dps?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(উ) প্রভিডেন্ট ফান্ড বা অন্যান্য ফান্ড (যদি থাকে)</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.financial_assets?.provident_fund_and_other_fund?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(ঊ) অন্যান্য বিনিয়োগ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.financial_assets?.other_financial_assets?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row my-2">
                                <div class="col-sm-9 text-center">মোট আর্থিক সম্পদ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{totalFinancialAssets | formatNumberReturnView}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ছ) মোটর যান (রেজিস্ট্রেশন খরচসহ ক্রয়মূল্য)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.motor_car?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2 mb-2">
                        <div class="col-sm-12" style="padding-left: 30px">মোটর যানের প্রকৃতি ও রেজিস্ট্রেশন নম্বর উল্লেখ করুন</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(জ) অলংকারাদি {{ornamentDetails}}</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.gold_diamond_gems_and_other_items?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ঝ) আসবাবপত্র ও ইলেকট্রনিক সামগ্রী</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.furniture_equipments_and_electronic_items?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-9" style="padding-left: 30px;">(ঞ) অন্যান্য পরিসম্পদ [ক্রমিক (ট) এ বর্ণিত সম্পদ ব্যতীত] (বিবরণ দিন)</div>
                        <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.other_assets_of_significant_value?.value | formatNumberReturnView}}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row mb-2">
                                <div class="col-sm-12" style="padding-left: 30px">
                                    (ট) ব্যবসা বহির্ভূত নগদ অর্থ ও তহবিল
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(অ) ব্যাংকে গচ্ছিত অর্থ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.cash_and_fund_outside_business?.notes_and_currencies?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9"  style="padding-left: 60px;">(আ) হাতে নগদ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3"></span>{{restructuredData?.assets?.cash_and_fund_outside_business?.hand_cash?.value | formatNumberReturnView}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-9" style="padding-left: 60px;">(ই) অন্যান্য অর্থ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.cash_and_fund_outside_business?.other_deposits_balance_and_advance?.value | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row my-2">
                                <div class="col-sm-9 text-center">মোট আর্থিক সম্পদ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{totalSavedCash | formatNumberReturnView}}</span></div>
                            </div>
                            <div class="row my-2">
                                <div class="col-sm-9 text-center">বাংলাদেশে অবস্থিত মোট পরিসম্পদ</div>
                                <div class="col-sm-3">টাকা <span class="ml-3">{{totalAssetsInsideBD | formatNumberReturnView}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-9">৯। বাংলাদেশের বাহিরে অবস্থিত পরিসম্পদ (প্রযোজ্যতা অনুসারে)</div>
                <div class="col-sm-3">টাকা <span class="ml-3">{{restructuredData?.assets?.outside_property?.value | formatNumberReturnView}}</span></div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-9">১০। বাংলাদেশে অবস্থিত ও বাংলাদেশের বাহিরে অবস্থিত মোট পরিসম্পদ (৮+৯)</div>
                <div class="col-sm-3">টাকা <span class="ml-3">{{totalAssets | formatNumberReturnView}}</span></div>
            </div>
        </div>
    </div>
  <div *ngIf="!returnData?.profileData?.mandatoryITTenB" class="row mb-5 mt-3">
    <div class="col-sm-12 ml-4"><b><i>
      বি. দ্র. আইটি-১০বি বাধ্যতামূলক নয় এবং শুধুমাত্র মোট পরিসম্পদ ঘোষণা করা হয়েছে।</i></b>
    </div>
  </div>
    <div class="row mb-5 mt-3">
        <div class="col-sm-12" style="margin-left: 30px">
            আমি ঘোষণা করিতেছি যে, আমার জ্ঞান ও বিশ্বাস মতে আইটি-১০বি (২০২৩) এ প্রদত্ত তথ্য সঠিক ও সম্পূর্ণ।
        </div>
    </div>
    <div class="row mb-3" style="margin-top:70px;">
        <div class="col-sm-6"></div>
        <div class="col-sm-6 d-flex flex-column align-items-center">
            <div class="pb-1 text-center">{{returnData?.profileData?.assesName}}</div>
            <div style="width:fit-content">
                করদাতার নাম ও স্বাক্ষর
                <br>
                তারিখ: {{dateAfterSign}}
            </div>
            <div class="pt-1 font-italic font-weight-bold">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।</div>
        </div>
    </div>
</div>
